import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ILanguageSwitchTransmissionMessage,
  messagingActions,
} from './messagingSlice';
import { EventTypes } from '../constants/event';
import { Languages, LANGUAGES } from '../utils/constants';

export interface LanguageState {
  currentLanguage: Languages;
}

const initialState: LanguageState = {
  currentLanguage: LANGUAGES.ENGLISH,
};

const languageSlice = createSlice({
  name: 'language',
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Languages>) => {
      state.currentLanguage = action.payload;
    },
    toggleLanguage: (state) => {
      state.currentLanguage =
        state.currentLanguage === LANGUAGES.ENGLISH
          ? LANGUAGES.SPANISH
          : LANGUAGES.ENGLISH;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(messagingActions.messageReceived, (state, action) => {
      const { messages = [], ai, sessionBoundarySessionId } = action.payload;
      messages.forEach((message) => {
        if (message.event === EventTypes.carEnter) {
          state.currentLanguage = LANGUAGES.ENGLISH;
        }
        if (message.event === EventTypes.languageSwitch) {
          // Handle language_switch events from buffered messages (e.g., from unsupervised mode)
          const newLanguage = (message as ILanguageSwitchTransmissionMessage)
            .data?.new_language;
          // Validate that it's a valid language value
          if (
            newLanguage === LANGUAGES.ENGLISH ||
            newLanguage === LANGUAGES.SPANISH
          ) {
            state.currentLanguage = newLanguage;
          }
        }
      });
    });
  },
});

export const { setLanguage, toggleLanguage } = languageSlice.actions;
export default languageSlice.reducer;
